import classNames from "classnames";
import React, { type ThHTMLAttributes } from "react";

import useCheckLocation from "@hooks/useCheckLocation";

interface IProps {
  titles: string[];
  data: string[][];
  className?: string | classNames.ArgumentArray;
}

export default function Table({ titles, data, className }: IProps) {
  return (
    <table className={classNames("table-fixed font-normal", className)}>
      <thead>
        <TableRow className="border-b border-black dark:border-b-white" data={titles} />
      </thead>
      <tbody>
        {data.map((rowData, index) => (
          <TableRow className="bg-white" data={rowData} key={index} />
        ))}
      </tbody>
    </table>
  );
}

interface ITableRowProps extends ThHTMLAttributes<HTMLTableRowElement> {
  data: string[];
}

function TableRow({ data, className }: ITableRowProps) {
  const { isDanielJohnston } = useCheckLocation();

  return (
    <tr className={classNames(className, isDanielJohnston ? "dark:bg-dj-black" : "dark:bg-black")}>
      {data.map((item, index) => (
        <td
          className={classNames(item.includes("Size") ? "w-17.5" : "min-w-10", "py-0.5 pr-4")}
          key={`${index}_${item}`}
        >
          {item}
        </td>
      ))}
    </tr>
  );
}
